// Integration codes
const integrationCodes = {
  a3innuva: '148642324',
  a3nom: '146392782',
  datev: '146479883',
  datev_api: '148440300',
  datev_lug_api: '177166166',
  datev_lauds_factorial: 'aoNL4KHjS0CDRdbtSQ1RjQ',
  paierh: '149038994',
  yeap_paierh: 'VOKHWDa2SziPUTFGjMAjKw',
  silae: '146479793',
  sage100: 'AzI2TWRbTA6ElJCDHPiALw',
  silae_fortify: 'Y0h_Sh7pRxCWpl0DySn_uQ',
  team_system: 'H98pPeUzQeSR5a_j0rNJyw',
  zucchetti: '146431400',
  gispaghe: 'N1Ex7A7LRW6XpUOPloOoGA',
  job_sistemi: 'EuNUvBZHRn-dvlOGO3tNeA',
  sage_200_gmintegra: '146471091',
  milena_illusion: 'efd0wxwNStWCGvCqIReOdg',
  indeed: '146407226',
  infojobs: 'HFe_bGxySDWQtY_kGL3cbw',
  welcome_to_the_jungle: 'Zv55pUKKQxy0BDgav9aBbQ',
  oracle_netsuite_bit_technologies: 'TIcEM9PmQ2GVpHzIdOp4HA',
  business_central_acicatech: 'cZly3nzXStqYaXzTJ3i6rg',
  suprema_xiptic: '144394392',
  whatsapp: '147083486',
  idealdisc: '147083451',
  zkteco_zkteco: '146471263',
} as const

export type IntegrationCodesTypes = (typeof integrationCodes)[keyof typeof integrationCodes]

export default integrationCodes
